import React from "react";
import "./Button.scss"
const Button = ({ isPrimary = true, buttonText, onClick, fontSize, fontWeight, width, isloading }) => {
    return (
        <div
            className={isPrimary ? "RewardsTick-button-primary" : "RewardsTick-button-secondary"}
            onClick={onClick}
            style={{ fontSize, fontWeight, width }}>
            {isloading && <div className="loader-btn" />}
            {buttonText}
        </div >
    )
}
export default Button